/*eslint-disable*/
export default {
    methods: {
        defineMinAndMax() {
            if (this.parameters.difficult.digits) {
                this.min = 0;
                this.max = this.parameters.difficult.digits.length;
            }
            if (this.parameters.difficult.thousands) {
                this.min = 1000;
                this.max = this.parameters.difficult.digits ?
                        this.parameters.difficult.digits.length*1000 + 999 : 9999;
            } else if (this.parameters.difficult.hundreds) {
                this.min = 100;
                this.max = this.parameters.difficult.digits ?
                        this.parameters.difficult.digits.length*100 + 99 : 999;
            } else if (this.parameters.difficult.tens) {
                this.min = 10;
                this.max = this.parameters.difficult.digits ?
                        this.parameters.difficult.digits.length*10 + 9 : 99;
            } else if (this.parameters.difficult.fiveDigit) {
                this.min = 10000;
                this.max = 99999;
            } else if (this.parameters.difficult.fourDigit) {
                this.min = 1000;
                this.max = 9999;
            } else if (this.parameters.difficult.threeDigit) {
                this.min = 100;
                this.max = 999;
            } else if (this.parameters.difficult.twoDigit) {
                this.min = 10;
                this.max = 99
            } else if (this.parameters.difficult.teens) {
                this.min = 10;
                this.max = 19;
            }
        },
    }
}
